// extracted by mini-css-extract-plugin
export var active = "CountBox-module--active--efef5";
export var count = "CountBox-module--count--a8342";
export var fadeInAnimation = "CountBox-module--fadeInAnimation--c78d3";